import React from "react";

const Toolbar = ({ setDrawMode, handleUndo }) => {
  return (
    <div style={{
      width: 80,
      backgroundColor: "#f5f5f5",
      borderRight: "1px solid #ccc",
      padding: 10,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      alignItems: "center"
    }}>
      {/* Rectangle tool */}
      <button onClick={() => setDrawMode("rect")} style={{ width: "100%" }}>
        ▭
      </button>

      {/* Arrow tool */}
      <button onClick={() => setDrawMode("arrow")} style={{ width: "100%" }}>
        ↝
      </button>

      {/* Undo last annotation */}
      <button onClick={handleUndo} style={{ width: "100%", color: "#666" }}>
        ↩️ Undo
      </button>
    </div>
  );
};

export default Toolbar;
